import { type ReactNode } from "react";
import { cn } from "../../utils";

type Props = {
  children: ReactNode;
  className?: string;
};

export const ModalBody = ({ children, className }: Props) => {
  return (
    <div data-drawer-body className={cn("flex-1 overflow-auto p-4", className)}>
      {children}
    </div>
  );
};
